<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-navigation-drawer id="navigation-drawer"
                         color="kbWhite"
                         v-model="openedDrawer"
                         :mini-variant="minimizedDrawer"
                         :mobile-breakpoint="$vuetify.breakpoint.thresholds.md"
                         mini-variant-width="70"
                         app
                         width="300">
      <TheToolBar :minimized-drawer="minimizedDrawer"
                  :opened-drawer="openedDrawer"
                  @toggleSideBar="toggleSideBar()"/>
      <v-card text
              color="kbWhite"
              style="max-height: 88%; overflow: hidden auto;"
              :style="{ paddingTop: !minimizedDrawer ? '20px' : '0' }"
              class="elevation-0">
        <v-card-text class="px-0 py-0">
          <v-list class="py-0">
            <template v-for="(listItem, index) in sideBarItems">
              <template v-if="listItem.subItems &&
                              Array.isArray(listItem.subItems) &&
                              listItem.subItems.length > 0 &&
                              listItem.shownCondition">
                <v-tooltip right
                           :key="`list-item-${index}`"
                           :disabled="!minimizedDrawer">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-list class="py-0">
                        <v-list-group no-action
                                      class="mx-2 px-0"
                                      :class="listItem.isSubItemSelected() && minimizedDrawer ?
                                              [listItem.icon.color, 'white--text', 'my-2', 'py-0'] : ''"
                                      :style="{ borderRadius: listItem.isSubItemSelected() && minimizedDrawer ? '10px' : '' }"
                                      @click.stop="toggleSideBar(true)"
                                      v-model="openedGroupList[listItem.subItemsValue]">
                          <template v-slot:activator>
                            <v-list-item-action class="justify-center custom-list-item-action mx-0" @click="toggleSideBar(true)">
                              <template v-if="listItem.image">
                                <img :src="listItem.isSubItemSelected() && minimizedDrawer ? listItem.image.srcWhite : listItem.image.src"
                                     :style="{ width: listItem.image.size || '30px' }"
                                     :alt="listItem.image.alt">
                              </template>

                              <template v-else>
                                <v-icon :color="listItem.isSubItemSelected() && minimizedDrawer ? 'white' : listItem.icon.color"
                                        :size="listItem.icon.size || '32px'">
                                  {{ listItem.icon.name }}
                                </v-icon>
                              </template>
                            </v-list-item-action>
                            <v-list-item-content class="ml-4">
                              <v-list-item-title class="kbDarkBlueText--text">
                                {{ listItem.name }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item :class="subItem.pathName === $route.name ? [listItem.icon.color, 'my-2', 'py-0'] : 'kbWhite'"
                                       :style="{ borderRadius: subItem.pathName === $route.name ? '10px' : '' }"
                                       @click="subItem.itemFunction()"
                                       v-for="(subItem, index) in listItem.subItems"
                                       :key="`sub-item-${index}`">
                            <v-list-item-title :class="subItem.pathName === $route.name ? 'white--text' : 'kbDarkBlueText--text'">
                              {{ subItem.name }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-group>
                      </v-list>
                    </div>
                  </template>
                  <span>{{ listItem.name }}</span>
                </v-tooltip>
              </template>

              <template v-else-if="!listItem.subItemsValue && listItem.shownCondition">
                <v-tooltip right
                           :key="`list-item-${index}`"
                           :disabled="!minimizedDrawer">
                  <template v-slot:activator="{ on }">
                    <v-list-item v-on="on"
                                 @click="listItem.itemFunction()"
                                 class="mx-2"
                                 :class="[listItem.pathName === $route.name ?
                                         [listItem.icon.color, 'white--text', 'my-2', 'py-0'] : '',
                                         minimizedDrawer ? 'mx-1' : '']"
                                 :style="{ borderRadius: listItem.pathName === $route.name ? '10px' : '' }">
                      <v-list-item-action class="justify-center custom-list-item-action mx-0" @click="toggleSideBar(true)">
                        <template v-if="listItem.image">
                          <img :src="listItem.pathName === $route.name ? listItem.image.srcWhite : listItem.image.src"
                               :style="{ width: listItem.image.size || '30px' }"
                               :alt="listItem.image.alt">
                        </template>
                        <template v-else>
                          <v-icon :color="listItem.pathName === $route.name ? 'white' : listItem.icon.color"
                                  :size="listItem.icon.size || '32px'">
                            {{ listItem.icon.name }}
                          </v-icon>
                        </template>
                      </v-list-item-action>
                      <v-list-item-content class="ml-4">
                        <v-list-item-title
                          :class="listItem.pathName === $route.name ? 'white--text' : 'kbDarkBlueText--text'"
                        >
                          {{ listItem.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <span>{{ listItem.name }}</span>
                </v-tooltip>
              </template>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/eventBus'
import SideBarMixin from '@/mixins/components/SideBarMixin'
import TheToolBar from '@/components/AppSideBar/TheToolBar'

export default {
  components: { TheToolBar },
  computed: {
    ...mapGetters(['companyUuid', 'sidebarModules'])
  },
  created () {
    EventBus.$on('toggleSideBar', () => { this.toggleSideBar(true) })
  },
  data () {
    return {
      minimizedDrawer: false,
      openedDrawer: true,
      openedGroupList: {
        people: false,
        communications: false,
        conversations: false,
        network: false,
        events: false,
        settings: false
      }
    }
  },
  methods: {
    closeListGroups () {
      this.openedGroupList = {
        people: false,
        communications: false,
        conversations: false,
        network: false,
        events: false,
        settings: false
      }
    },
    toggleSideBar (value = false) {
      if (value) {
        this.minimizedDrawer = !value
        this.openedDrawer = value
      } else {
        if (!this.minimizedDrawer) {
          this.closeListGroups()
        }
        this.minimizedDrawer = !this.minimizedDrawer
        if (this.$vuetify.breakpoint.mdAndDown) {
          this.openedDrawer = !this.openedDrawer
        }
      }
    }
  },
  mixins: [SideBarMixin]
}
</script>

<style lang="scss" scoped>
  nav#navigation-drawer {
    ::v-deep {
      .v-navigation-drawer__border {
        z-index: 4;
      }
      .v-navigation-drawer--mini-variant .v-list-item {
        padding: 0 6px;
      }
      div.v-navigation-drawer__content {
        overflow: hidden;
      }
      div.v-card.v-sheet::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
      }
      div.v-card.v-sheet::-webkit-scrollbar {
        width: 6px;
        background-color: #f5f5f5;
        display: none;
      }
      div.v-card.v-sheet:hover::-webkit-scrollbar {
        display: block;
      }
      div.v-card.v-sheet::-webkit-scrollbar-thumb {
        background-color: #4d4f5c;
      }
      // modifies width of icon arrow down
      .v-list-item__icon {
        min-width: 26px;
        margin-left: 2px;
      }
      // modifies properties for list-item-group-icon:
      .v-list-group__header__prepend-icon {
        margin-right: 8px;
      }
      // modifies properties for list-item-icon:
      .v-list-item__action.custom-list-item-action {
        min-width: 50px!important;
        max-width: 50px!important;
        text-align: center!important;
      }
    }
    .v-list-item__action, .v-list-item__avatar, .v-list-item__icon {
      min-width: 50px!important;
      max-width: 50px!important;
    }
    .side-bar--item__active {
      background-color: rgba(59, 89, 152, 0.1);
    }
  }
</style>
